var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 39,
    viewBox: "0 0 32 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 20C17.0555 20 17.9582 19.6244 18.7096 18.873C19.4609 18.1217 19.8359 17.2196 19.8346 16.1667C19.8346 15.1125 19.459 14.2098 18.7076 13.4585C17.9563 12.7071 17.0542 12.3321 16.0013 12.3334C14.9471 12.3334 14.0444 12.709 13.2931 13.4604C12.5417 14.2117 12.1667 15.1138 12.168 16.1667C12.168 17.2209 12.5436 18.1236 13.295 18.875C14.0463 19.6263 14.9484 20.0013 16.0013 20ZM16.0013 38.448C15.7457 38.448 15.4902 38.4 15.2346 38.3042C14.9791 38.2084 14.7555 38.0806 14.5638 37.9209C9.89991 33.8 6.41797 29.9744 4.11797 26.4439C1.81797 22.9134 0.667969 19.6154 0.667969 16.55C0.667969 11.7584 2.20961 7.94101 5.29289 5.09796C8.37616 2.2549 11.9456 0.833374 16.0013 0.833374C20.0582 0.833374 23.6284 2.2549 26.7116 5.09796C29.7949 7.94101 31.3359 11.7584 31.3346 16.55C31.3346 19.6167 30.1846 22.9153 27.8846 26.4458C25.5846 29.9763 22.1027 33.8013 17.4388 37.9209C17.2471 38.0806 17.0235 38.2084 16.768 38.3042C16.5124 38.4 16.2569 38.448 16.0013 38.448Z",
    fill: "#1650FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerIcon);
export default __webpack_public_path__ + "static/media/markerIcon.c7f63045747b0d9ceb17a448a4da0500.svg";
export { ForwardRef as ReactComponent };